import { LitElement, html } from 'lit-element';
import loadCssForComponent from '@twebcomponents/web-components-common/js/xhttp/loadCssForComponent.js';
import getRequestWithCallback from '@twebcomponents/web-components-common/js/xhttp/getRequestWithCallback.js';
import TRANS_DICT from './en-Us/trans_dict';
import SnackBar from '@twebcomponents/snack-bar/src/snack-bar.js';
import addScrollToSiblingElement from '@twebcomponents/web-components-common/js/dom/addScrollToSiblingElement.js';

class InviteUserPopup extends LitElement {

  static get properties() {
    return {
      apiUri: {
        type: String,
        attribute: 'api-uri'
      },
      accessToken: {
        type: String,
        attribute: 'access-token'
      },
      openPopup: {
        type: String,
        attribute: 'open-popup'
      },
      projectAsString: {
        type: String,
        attribute: 'project-as-string'
      },
      autoScroll: {
        type: String,
        attribute: 'auto-scroll'
      },
      transDict: {
        type: String,
        attribute: 'trans-dict'
      },
      showSnackbarMessage: {
        type: String,
        attribute: 'show-snackbar-message'
      },
      openAsModel: {
        type: String,
        attribute: 'open-as-modal'
      },
      skipApiCall: {
        type: String,
        attribute: 'skip-api-call'
      },
      defaultConfigAsString:{
        type:String,
        attribute: "default-config-as-string"
      },
    };
  }
  constructor(defaultAttributes) {
    super();
    this.resourcesUrl = 'https://resources.connect.trimble.com/1.11.0';
    this.translationDict = TRANS_DICT || {};
    this.showPopup = false;
    this.showGroupDropdown = false;

    this.inviteUsers = [];
    this.hasValidInviteUsers = true;
    this.accessToken = this.apiUri = null;
    this.projectObject = {};
    this.userRoleToProject = 'USER';
    this.projectGroups = [];
    this.userCompanies = [];
    this.inviteUsersRole = 'USER';
    this.selectedGroup = '';
    this.pendingInviteUsers = [];
    this.alreadyExistUsers = [];
    this.newUsers = [];
    this.snackBarMessages = [];
    this.isAutoScroll = true;
    this.autoScrollPlaceholder = this.translationDict['LOADED_X_FROM_Y_USERS'];
    this.autoScrollMessage = '';
    this.nonAutoScrollPlaceholder = this.translationDict['LOADED_X_FROM_Y_USERS'] + this.translationDict['SCROLL_DOWN_FOR_MORE_USERS'];
    this.nonAutoScrollMessage = '';
    this.stillLoadingUsers = false;
    this.stillLoadingUsersPlaceholder = this.translationDict['STILL_LOADING_Z_USERS'];
    this.loadingUsersPostfixMessage = this.translationDict['SEARCH_ON_LOADED_USERS'];
    this.showSnackbarMessage = true;
    this.openAsModel = true;
    this.skipApiCall = 'false';
    this.defaultConfigAsString = {};
    this.defaultRoles = ['USER'];
    defaultAttributes = defaultAttributes || {};
    Object.keys(defaultAttributes).forEach(function(attrKey){
      if( defaultAttributes[attrKey] != null ) {
        this.setAttribute(attrKey, defaultAttributes[attrKey]);
      }
    }.bind(this));
  }
  connectedCallback() {
    super.connectedCallback();
    loadCssForComponent(this, 'invite-popup-container', [this.resourcesUrl + '/fonts/icon-font.min.css']);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue && newValue != 'null' && (name == 'default-config-as-string' || name == 'trans-dict' ? true  : newValue.indexOf('{{') == -1 )) { // excluding the check as the translation can have {{ in translation strings
      switch (name) {
        case 'open-popup':
          this.showPopup = (newValue == 'true')? true: false;
          //this.shadowRoot.querySelector(".alert").style.color = this.textColor;
          if( oldValue != newValue) {
            this.requestUpdate('showPopup');
          }
        break;
        case 'access-token':
          this.accessToken = newValue || this.accessToken;
        break;
        case 'project-as-string':
          this.projectObject = JSON.parse(newValue) || this.projectObject;
        break;
        case 'trans-dict':
          this.translationDict = Object.assign(this.translationDict, JSON.parse(newValue)) || this.translationDict;
        break;
        case 'api-uri':
          this.apiUri = newValue || this.apiUri;
        break;
        case 'auto-scroll':
          this.isAutoScroll = newValue || this.isAutoScroll;
        break;
        case 'show-snackbar-message':
          this.showSnackbarMessage = (newValue && newValue === "false")? false : true;
        break;
        case 'open-as-modal':
          this.openAsModel = (newValue && newValue === "false")? false : true;
        break;
        case 'skip-api-call':
          this.skipApiCall = (newValue && newValue === "false")? 'false' : 'true';
        break;
        case 'default-config-as-string':
          this.loadComponentConfig(JSON.parse( newValue));
          //this.requestUpdate('results');
        break;
      }
      if( (name == 'api-uri' || name == 'access-token' || name == 'project-as-string')
          && this.accessToken && this.apiUri && this.projectObject.id && this.skipApiCall == 'false'){
        this.fetchUserRoleAndProjectGroups(this.projectObject);
      }
    }
  }

  render() {
    //For IE jquery + qtip issues
    this.shadowRoot.getAttribute = function () {
      return true;
    }
    return html`
    <style>{{COMP_CSS}}</style>
    <style>
      .reveal-overlay {
        display: block;
      }
      .reveal-overlay.not-modal {
        background: transparent;
      }
      .load-view {
        text-align: center;
      }
      .reveal.not-modal {
        box-shadow: none;
      }
      .reveal section {
        overflow: hidden;
      }
      .reveal section .search-result {
        overflow: hidden auto;
        max-height: 15rem;
      }
      .dropdown-pane .dropdown-list li span {
        width: 90%;
        overflow: hidden;
        text-overflow: ellipsis;
      }

    </style>
    <div id="invite-popup-container">
      <snack-bar id="snack-bar-message"></snack-bar>
      ${this.showPopup ?
        html`<div class="reveal-overlay ${!this.openAsModel?  'not-modal' : ''}">
            <div class="reveal-container"><div class="reveal ${!this.openAsModel? 'not-modal': ''}">
          <header>
            <h2>${ this.translationDict['INVITE_OTHER_TO_PROJECT'].replace("#ObjectName#", this.projectObject.name || '')}</h2>
            <button class="button icon-circle icon-medium tertiary"
                    @click="${(e) => this.setProperty('showPopup', false)}">
                <i class="icon-font tc-icon-content-close"></i>
            </button>
          </header>
          <section class="scroll-section" @scroll=${(e) => addScrollToSiblingElement(e.target)}>
              <div class="input-group tags">
                <label>${ this.translationDict['PEOPLE'] }</label>
                <div class="group-items input-focus-group ${this.hasValidInviteUsers? '' : 'error'}">
                  ${ this.renderAddInviteBox() }
                </div>
                <div id="tmpInviteEmail-line" class="line input-highlight ${!this.hasValidInviteUsers? 'error': ''}"></div>
                ${!this.hasValidInviteUsers? html`<label class="error-message">${this.translationDict['ENTER_VALID_EMAIL']}</label>`: ''}
              </div>
              ${ this.renderGroup() }
              ${ this.renderRole() }
          </section>
          <footer>
            <hr/>
            <div class="wrap-buttons">
              <button class="button link-secondary" @click="${(e) => this.setProperty('showPopup', false)}">${this.translationDict['CANCEL']}</button>
              <button class="button primary" ?disabled="${!this.hasValidInviteUsers || !this.inviteUsers.length}" @click="${(e) => this.inviteUserToProject()}">${this.translationDict['INVITE']}</button>
            </div>
          </footer>
            </div></div>` : ''}
    </div>`;
  }
  renderAddInviteBox() {
    return html `<ul>
        ${this.inviteUsers.map((inviteUser, index) => html`
        <li class="chips ${inviteUser.isValid ? '' : 'error'}">
          <span title="${inviteUser.email}">${inviteUser.email}</span>
          <button class="button tertiary icon-small icon-circle" @click="${ (e) => this.removeFromInviteUsers(index)}">
              <i class="icon-font tc-icon-cancel i16"></i>
          </button>
        </li>
        `)}
        <li>
          <input type="text" id="tmpInviteEmail"
                size="15"
                placeholder="${this.inviteUsers.length? this.translationDict['ADD_MORE_PEOPLE'] : this.translationDict['ADD_PEOPLE']}"
                @focus="${(e) => this.shadowRoot.querySelector("#tmpInviteEmail-line").classList.add("focus")}"
                @keyup="${(e) => this.onChangeText(e)}" @blur="${(e) => this.onBlurText(e)}"/>
        </li>
    </ul>`;
  }
  renderGroup() {
    return html `${ (this.userRoleToProject == 'ADMIN' || this.projectGroups.length > 1) ?
      html`
        ${this.showGroupDropdown ? '' :
          html`<button class="button link-secondary inline-left" @click="${(e) => this.setProperty('showGroupDropdown', true)}">${this.translationDict['ADD_TO_GROUP']}</button>`
        }
        ${this.showGroupDropdown ?
          html`<div class="input-group">
            <label>${this.translationDict['GROUPS']}</label>
            <select name="selected-group" id="selected-group" @change="${(e) => this.setSelectedGroup()}">
                <option value="">${this.translationDict['SELECT_A_GROUP']}</option>
                ${this.projectGroups.map((group) => html`
                  <option value="${group.id}">${group.name}</option>
                `)}
            </select>
          </div>`: ''
        }` : ''
    }`;
  }
  renderRole() {
    return html `<div class="input-group checkradio">
      <label>${this.translationDict['ROLE']}</label>
      ${ this.defaultRoles.map( (defaultRole) => html `
        <div class="group-items">
          <div class="icon radio">
            <input class="custom-input" name="role" type="radio"
              ?checked="${this.inviteUsersRole == defaultRole}"
              @click="${(e) => this.setRoleForInviteUsers(defaultRole)}">
            <label></label>
          </div>
          <label>${this.translationDict[defaultRole]}</label>
        </div>
      `)}`;
  }
  updated(changedProperties) {
    if( changedProperties.has('inviteUsers') ) {
      this.updateInviteUsersHasValidEmail();
    }
    if(changedProperties.has('snackBarMessages')) {
      if( this.snackBarMessages ) {
        this.setProperty('showPopup', false);
      }
    }

    if(changedProperties.has('showPopup')) {
      const textInput = this.shadowRoot.getElementById("tmpInviteEmail");
      if( textInput ) {
        textInput.focus();
      }
      if( this.showPopup === false && this.getAttribute('open-popup') != 'false' ) {
        this.inviteUsers = [];
        this.projectGroups = [];
        this.showGroupDropdown = false;
        this.hasValidInviteUsers = true;
        this.projectObject = {};
        this.setAttribute('open-popup', 'false');
        this.dispatchEvent(new CustomEvent('on-close', { detail: { message: 'CLOSED' } }));
      }
    }
  }
  loadComponentConfig(config){
    this.translationDict = (config.translations)? Object.assign(this.translationDict, config.translations) : this.translationDict;
    this.defaultRoles = (config.defaultRoles)? config.defaultRoles : this.defaultRoles;
    //console.log(config);
    if( config.translations && Object.keys(config.translations).length > 0) {
      this.requestUpdate('translationDict');
    }
    if( config.defaultRoles && config.defaultRoles.length > 0 ) {
      this.requestUpdate('defaultRoles');
    }
    if( config.defaultGroups && config.defaultGroups.length > 0 ) {
      this.projectGroups = (config.defaultGroups)? config.defaultGroups: this.defaultGroups;
      this.requestUpdate('projectGroups');
    }
    if( config.inviteObject && Object.keys(config.inviteObject).length > 0 ) {
      this.projectObject = (config.inviteObject)? config.inviteObject: this.projectObject;
      //console.log(this.projectObject);
      this.requestUpdate('projectObject');
    }
    //console.log(this.defaultRoles, this.projectGroups, this.projectObject);
  }
  toggleProperty(prop, value) {
    this[prop] = !this[prop];
    this.requestUpdate(prop);
  }
  setProperty(prop, value) {
    this[prop] = value;
    this.requestUpdate(prop);
  }
  onChangeText(event) {
    var tmpInviteEmail = this.shadowRoot.getElementById("tmpInviteEmail").value;
    this.shadowRoot.getElementById("tmpInviteEmail").setAttribute("size", tmpInviteEmail.length );
    var key = event.which || event.keyCode || event.charCode;
    if( key == 8 && !tmpInviteEmail) {
      this.removeFromInviteUsers(this.inviteUsers.length-1);
    } else if( (key == 13 || key == 188) && tmpInviteEmail) {
      tmpInviteEmail = (key == 188 )? tmpInviteEmail.replace(",", "") : tmpInviteEmail;
      this.addToInviteUsers(tmpInviteEmail);
      this.shadowRoot.getElementById("tmpInviteEmail").setAttribute("size", 15);
      this.shadowRoot.getElementById("tmpInviteEmail").scrollIntoView();
    }
  }
  onBlurText(){
    var tmpInviteEmail = this.shadowRoot.getElementById("tmpInviteEmail").value;
    this.shadowRoot.querySelector("#tmpInviteEmail-line").classList.remove("focus")
    if(tmpInviteEmail){
      this.addToInviteUsers(tmpInviteEmail);
    }
  }
  addToInviteUsers(tmpInviteEmail){
    this.inviteUsers.push({email: tmpInviteEmail, isValid: /\S+@\S+\.\S+/.test(tmpInviteEmail)});
    this.shadowRoot.getElementById("tmpInviteEmail").value = '';
    this.requestUpdate('inviteUsers');
  }
  removeFromInviteUsers(index) {
    this.inviteUsers.splice(index, 1);
    this.requestUpdate('inviteUsers');
  }
  updateInviteUsersHasValidEmail() {
    if( this.inviteUsers.length ) {
      var findIndex = this.inviteUsers.findIndex(function(user){
        return user.isValid === false;
      });
      this.hasValidInviteUsers = (findIndex == -1);
      this.requestUpdate('hasValidInviteUsers');
    } else {
      this.hasValidInviteUsers = true;
      this.requestUpdate('hasValidInviteUsers');
    }
  }
  setRoleForInviteUsers(role){
    this.inviteUsersRole = role;
    this.requestUpdate('inviteUsersRole');
  }
  setSelectedGroup() {
    this.selectedGroup = this.shadowRoot.getElementById('selected-group').value;
    this.requestUpdate('selectedGroup');
  }
  setUserRole(event) {
    if( (event.target.status == 200 ) && event.target.readyState == 4){
      let tmpAllRoles = JSON.parse(event.target.response);
      this.userRoleToProject = ( tmpAllRoles.indexOf('ADMIN') > -1)? 'ADMIN' : 'USER';
      if(this.userRoleToProject == 'ADMIN') {
        this.defaultRoles = ['USER', 'ADMIN'];
        this.requestUpdate('defaultRoles');
      } else {
        this.defaultRoles = ['USER'];
        this.requestUpdate('defaultRoles');
      }
    }
  }
  inviteUserToProject(){
    this.dispatchEvent(new CustomEvent('on-accept', { detail: {
      emails: this.inviteUsers.map((inviteUser) => {
        return inviteUser.email;
      }),
      option1: this.selectedGroup,
      option2: this.inviteUsersRole,
      inviteObject: this.projectObject
    } }));
    if( this.skipApiCall == 'false' ) {
      this.pendingInviteUsers = this.inviteUsers.slice(0);
      this.inviteUsers = [];
      this.requestUpdate('inviteUsers');
      this.snackBarMessages = [];
      this.requestUpdate('snackBarMessages');
      this.pendingInviteUsers.forEach((inviteUser, index) => {
        var tmpRequest = {
          "email": inviteUser.email,
          "role": this.inviteUsersRole
        };
        if(this.selectedGroup) {
          tmpRequest.group = this.selectedGroup;
        }
        getRequestWithCallback('POST', this.apiUri + '/projects/' + this.projectObject.id + '/users', {
          "Content-type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        }, JSON.stringify(tmpRequest), (e) => this.onEmailSent(e, inviteUser.email, index));
      });
    } else {
      this.setAttribute('open-popup', 'false');
      this.dispatchEvent(new CustomEvent('on-close', { detail: {message: 'CLOSED'} }));
    }
  }
  onEmailSent(event, email, i){
    if( event.target.readyState == 4 ) {
      if( event.target.status == 200 ){
        var userObj = JSON.parse(event.target.response);
        var findIndex = this.pendingInviteUsers.findIndex(function(user){
          return user.email == email;
        });
        this.pendingInviteUsers.splice(findIndex, 1);
        if(userObj.id) {
          this.alreadyExistUsers.push({"id": userObj.id, "email": email});
        } else {
          this.newUsers.push({"email": email});
        }
        if(this.pendingInviteUsers.length == 0){
          var tmpInviteSuccessMessage = this.translationDict['INVITATION_SENT'];
          this.setSnackBarMessage(tmpInviteSuccessMessage);
          this.newUsers = [];
          this.alreadyExistUsers = [];
          this.requestUpdate('newUsers');
          this.requestUpdate('alreadyExistUsers');
        }
      } else if( event.target.status == 400  ) {
        var error = JSON.parse(event.target.response);
        var tmpInviteSuccessMessage = '';
        if( error.errorcode == 'USER_ACTIVE_IN_PROJECT') {
          tmpInviteSuccessMessage = ' ' + this.translationDict['EMAIL_ALREADY_EXIST_IN_PROJECT'].replace("{{Email}}", email);
        } else  {
          tmpInviteSuccessMessage = ' ' + this.translationDict['EMAIL_IS_INVALID'].replace("{{Email}}", email);
        }
        this.setSnackBarMessage(tmpInviteSuccessMessage);
        this.pendingInviteUsers.splice(findIndex, 1);
      } else if( event.target.status == 401 ) {
        this.setSnackBarMessage("Invalid token or token expired");
        this.pendingInviteUsers.splice(findIndex, 1);
      } else if( event.target.status == 404 ) {
        this.setSnackBarMessage("Project not found");
        this.pendingInviteUsers.splice(findIndex, 1);
      }
    }
  }
  setSnackBarMessage(message) {
    if( this.showSnackbarMessage ) {
      this.shadowRoot.getElementById("snack-bar-message").setAttribute('display-text', message);
    }
    this.setAttribute('open-popup', 'false');
    this.dispatchEvent(new CustomEvent('on-close', { detail: {message: message} }));
  }
  loadProjectGroups(event) {
    if( (event.target.status == 200 ) && event.target.readyState == 4){
      this.projectGroups = JSON.parse(event.target.response);
    }
  }

  fetchUserRoleAndProjectGroups(project) {
    if( project && project.id ) {
      getRequestWithCallback('GET', this.apiUri + '/projects/' + project.id +'/roles', {
        "Content-type": "application/json",
        "Authorization": "Bearer " + this.accessToken,
      }, null, (e) => this.setUserRole(e));
      getRequestWithCallback('GET', this.apiUri + '/groups?projectId='+ project.id, {
        "Content-type": "application/json",
        "Authorization": "Bearer " + this.accessToken,
      }, null, (e) => this.loadProjectGroups(e));
    }
  }
}

window.customElements.define('invite-user-popup', InviteUserPopup);

export default InviteUserPopup;
window.InviteUserPopup = InviteUserPopup;